export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_ASSESSMENT_REQUEST = "FETCH_ASSESSMENT_REQUEST";
export const UPDATE_ASSESSMENT_REQUEST = "UPDATE_ASSESSMENT_REQUEST";
